import React from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "rsuite";
import "./PlayStoreModal.scss";
import SellerPlayStoreImg from "../../../assets/images/SellerPlayStoreImg.png";
import GooglePlayIcon from "../../../assets/images/GooglePlayIcon.png";
import SellerHubScreen from "../../../assets/images/SellerHubScreen.png";
import { QRCodeCanvas } from "qrcode.react";
import { MdClose, MdStorefront, MdTrendingUp, MdAssignment } from "react-icons/md";

const PlayStoreModal = ({ isVisible, onClose }) => {
  const { t } = useTranslation();
  const downloadLink =
    "https://play.google.com/store/apps/details?id=com.sellerhub&hl=en_IN";
  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      footer={null}
      className="download-app-modal"
    >
      <div className="playStore-button" onClick={onClose}>
        <MdClose />
      </div>
      <Modal.Body>
        <div className="modal-top-content">
          <div className="qr-footer-logos">
            <img src={SellerHubScreen} alt="Easy Pay" />
          </div>

          <div className="qr-container">
            <h4>{t("playStore.scanToDownload")}</h4>
            <div className="qr-code-wrapper">
              <a href={downloadLink} target="_blank" rel="noopener noreferrer">
                <QRCodeCanvas
                  value={downloadLink}
                  //size={180}
                  size={160}
                  level="H"
                  imageSettings={{
                    src: SellerPlayStoreImg,
                    height: 70,
                    width: 70,
                    excavate: true,
                  }}
                />
                <span className="playStore-hover-text">
                  {t("playStore.scanOrClick")}
                </span>
              </a>
            </div>
            <span>{t("playStore.scanOrClick")}</span>
            <div className="dashed-or">
              <span>OR</span>
            </div>

            <div className="google-icon">
              <a href={downloadLink} target="_blank" rel="noopener noreferrer">
                <img src={GooglePlayIcon} alt="GooglePlayIcon" />
              </a>
            </div>
          </div>
        </div>

        <div className="download-app-footer">
          <div className="footer-features">
            <div className="footer-feature">
              <span className="feature-icon">
                <MdStorefront />
              </span>
              <span>{t("playStore.manageBusiness")}</span>
            </div>
            <div className="feature-divider" />
            <div className="footer-feature">
              <span className="feature-icon">
                <MdTrendingUp />
              </span>
              <span>{t("playStore.trackSales")}</span>
            </div>
            <div className="feature-divider" />
            <div className="footer-feature">
              <span className="feature-icon">
                <MdAssignment />
              </span>
              <span>{t("playStore.easyOrders")}</span>
            </div>
          </div>
          <div className="footer-banner">{t("playStore.footerTagline")}</div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PlayStoreModal;
